import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const AP_INVOICE_URL = `${backendUrl}/apInvoice`;

const initialState = {
  isLoading: false,
  error: null,
  apInvoices: [],
  apInvoice: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "accountsApInvoice",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getApInvoicesSuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.apInvoices = payload.results || [];
      state.page = payload.page || 1;
      state.limit = payload.limit || 10;
      state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults || 0;
    },
    getApInvoiceSuccess(state, action) {
      state.isLoading = false;
      state.apInvoice = action.payload;
    },
    clearApInvoice(state) {
      state.apInvoice = null;
      state.error = null;
    },
  },
});

export default slice.reducer;

export function getAccountsApInvoices({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(AP_INVOICE_URL, {
        params: { franchiseId, warehouseId, page, limit },
      });
      dispatch(slice.actions.getApInvoicesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getAccountsApInvoice(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${AP_INVOICE_URL}/${id}`);
      dispatch(slice.actions.getApInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function createAccountsApInvoice(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(AP_INVOICE_URL, data);
      dispatch(slice.actions.getApInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateAccountsApInvoice(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${AP_INVOICE_URL}/${id}`, data);
      dispatch(slice.actions.getApInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export const { clearApInvoice } = slice.actions;
